import { useEffect } from 'react';

import {
  ThemeProvider as MuiThemeProvider,
  StylesProvider,
} from '@material-ui/styles'; // v1.x
import { Helmet } from 'react-helmet';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from 'styled-components';
import { createFragmentContainer, graphql } from 'react-relay';
import { DialogProvider } from '@feedback/dialog';
import { SnackbarProvider as SnackbarProviderUI } from '@feedback/ui';
import { SnackbarProvider } from 'notistack';
import MomentUtils from '@date-io/moment';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import { HiringProviders_query } from './__generated__/HiringProviders_query.graphql';

import { theme } from './components/Theme';

import i18n from './i18n/i18n';
import createQueryRendererModern from './relay/createQueryRendererModern';

type Props = {
  query: HiringProviders_query;
  children: React.ReactNode;
};
const HiringProviders = ({ query, children }: Props) => {
  const { company } = query;
  const lang = company?.lang || 'pt-BR';

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  return (
    <>
      <Helmet>
        <title>Contrata Você!</title>
        <link
          rel='stylesheet'
          href='https://fonts.googleapis.com/css?family=Material+Icons'
        />
      </Helmet>
      <StylesProvider injectFirst>
        <MuiThemeProvider theme={theme}>
          <ThemeProvider key='theme-provider' theme={theme}>
            <I18nextProvider i18n={i18n}>
              <SnackbarProviderUI>
                <SnackbarProvider>
                  <DialogProvider>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      {children}
                    </MuiPickersUtilsProvider>
                  </DialogProvider>
                </SnackbarProvider>
              </SnackbarProviderUI>
            </I18nextProvider>
          </ThemeProvider>
        </MuiThemeProvider>
      </StylesProvider>
    </>
  );
};

export const HiringProvidersFragmentContainer = createFragmentContainer(
  HiringProviders,
  {
    query: graphql`
      fragment HiringProviders_query on Query {
        company: companyDomainName {
          lang
        }
      }
    `,
  },
);

export default createQueryRendererModern(HiringProvidersFragmentContainer, {
  query: graphql`
    query HiringProvidersQuery {
      ...HiringProviders_query
    }
  `,
  loadingView: null,
});
